import React from 'react';
import { motion } from 'framer-motion';
import { AlertIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function PainAgitation() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-brand-bg-light relative overflow-hidden" data-id="element-236">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-red to-transparent opacity-50" data-id="element-237"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-239">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-240">
            <AlertIcon className="w-10 h-10 text-brand-red" data-id="element-241" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-242">
              {t('pain.title')}
            </h2>
          </div>

          <div className="space-y-8 text-lg sm:text-xl text-gray-300" data-id="element-243">
            <p data-id="element-244">{t('pain.p1')}</p>
            <p data-id="element-245">{t('pain.p2')}</p>

            <div className="bg-brand-bg-dark p-6 rounded-lg border border-gray-800 space-y-4 my-8 shadow-inner" data-id="element-246">
              {t('pain.quotes').map((quote: string, index: number) => <p key={index} className="italic text-gray-400" data-id="element-247">
                  {quote}
                </p>)}
            </div>

            <p data-id="element-248">{t('pain.p3')}</p>

            <div className="bg-brand-red/5 border-l-4 border-brand-red p-6 my-10" data-id="element-249">
              <p className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-250">
                {t('pain.cost_before')}
                <span className="text-brand-gold" data-id="element-251">
                  {t('pain.cost_300')}
                </span>{' '}
                {t('pain.cost_mid')}{' '}
                <span className="text-brand-red" data-id="element-252">{t('pain.cost_1200')}</span>
                {t('pain.cost_after')}
              </p>
            </div>

            <p data-id="element-253">{t('pain.p4')}</p>

            <p className="font-medium text-white border-b border-gray-800 pb-4 inline-block" data-id="element-254">
              {t('pain.p5')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}